"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
const TokenLockingFactory_1 = require("../contracts/4/TokenLockingFactory");
const getTokenLockingClient = (address, signerOrProvider) => {
    const tokenLockingClient = TokenLockingFactory_1.TokenLockingFactory.connect(address, signerOrProvider);
    tokenLockingClient.clientType = constants_1.ClientType.TokenLockingClient;
    return tokenLockingClient;
};
exports.default = getTokenLockingClient;
